import React from 'react';
import './App.css';

function App() {
  return (
    <div className="app-container">
      <header className="app-header">
        <h1>Welcome to gert</h1>
        <p>Your React application scaffold is ready.</p>
      </header>
      <main className="app-main">
        <p>Edit <code>src/App.js</code> and save to reload.</p>
      </main>
    </div>
  );
}

export default App;